<template>
  <base-list-layout :title="'Account'">
    <template #search>
      <el-form :inline="true" label-width="120px" :model="consoleAccount">
        <el-form-item label="Account ID">
          <el-input v-model="consoleAccount.accountId" placeholder="account id regex here ..." />
        </el-form-item>
        <el-form-item label="Account Name">
          <el-input
            v-model="consoleAccount.accountName"
            placeholder="account name regex here ..."
          />
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" @click="searchListClick(1)">Search</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="addClick">Create</el-button>
    </template>

    <template #table>
      <el-table
        v-loading="listLoading"
        style="width:100%;"
        height="70vmin"
        stripe
        border
        :data="consoleAccountList"
        highlight-current-row
      >
        <el-table-column type="expand">
          <template slot-scope="scopes">
            <el-table :data="scopes.row.roles" border stripe>
              <el-table-column label="Role Id" prop="id" align="center"></el-table-column>
              <el-table-column label="Role Name" prop="roleName" align="center"></el-table-column>
              <el-table-column label="Role Desc" prop="roleDesc" align="center"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="Account ID" prop="accountId" align="center"></el-table-column>
        <el-table-column
          label="Account Name"
          prop="username"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="Email"
          prop="email"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column label="Open Source" prop="isOpenAllAdv" align="center" min-width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.isOpenAllAdv > 0">Yes</span>
            <span v-else>No</span>
          </template>
        </el-table-column>
        <el-table-column label="Open Affiliate" prop="isOpenAllAff" align="center" min-width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.isOpenAllAff > 0">Yes</span>
            <span v-else>No</span>
          </template>
        </el-table-column>
        <el-table-column label="Description" prop="description" align="center"></el-table-column>
        <el-table-column label="Action" align="center">
          <template slot-scope="scope">
            <el-dropdown placement="right-start">
              <el-button type="primary" size="small">
                More Action<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  ><el-button
                    type="primary"
                    size="small"
                    :style="{ width: '100%', marginTop: '5px' }"
                    @click="updateClick(scope.row)"
                    >Add Or Update Role</el-button
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><el-button
                    type="primary"
                    size="small"
                    :style="{ width: '100%', marginTop: '5px' }"
                    @click="updateAccountClick(scope.row)"
                    >Update</el-button
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><el-button
                    type="danger"
                    size="small"
                    :style="{ width: '100%', marginTop: '5px' }"
                    @click="delAccountClick(scope.row)"
                    >Delete</el-button
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="pageSize"
        :currentPage="currentPage"
      />
    </template>

    <template #dialog>
      <el-dialog
        :title="dialogType === 'new' ? 'Create Account' : 'Update Account'"
        width="60%"
        :visible.sync="dialogVisible"
      >
        <el-form
          label-position="left"
          :model="account"
          label-width="130px"
          :rules="rules"
          class="grid-form"
          ref="baseForm"
        >
          <template v-if="dialogType === 'new'">
            <el-form-item label="Account Name" prop="username">
              <el-input v-model="account.username" placeholder="affiliate name here ..." />
            </el-form-item>
            <el-form-item label="Email" prop="email">
              <el-input v-model="account.email" />
            </el-form-item>
            <el-form-item label="Password">
              <el-input v-model="account.password" placeholder="affiliate password here ..." />
            </el-form-item>
            <el-form-item label="Description">
              <el-input v-model="account.description" placeholder="description here ..." />
            </el-form-item>
            <el-form-item label="Account Role">
              <el-select v-model="account.roles" multiple>
                <el-option
                  v-for="item in roleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select> </el-form-item
            ><el-form-item label="Open Sources">
              <el-select v-model="account.isOpenAllAdv" placeholder="Sources">
                <el-option
                  v-for="item in isOpenAllAdvOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Open Affiliates">
              <el-select v-model="account.isOpenAllAff" placeholder="Affiliates">
                <el-option
                  v-for="item in isOpenAllAffOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-if="dialogType === 'edit'">
            <el-form-item label="Email" prop="email">
              <el-input v-model="account.email" />
            </el-form-item>
            <el-form-item label="Description">
              <el-input v-model="account.description" placeholder="description here..." />
            </el-form-item>
            <el-form-item label="Open Sources">
              <el-select v-model="account.isOpenAllAdv" placeholder="Sources">
                <el-option
                  v-for="item in isOpenAllAdvOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Open Affiliates">
              <el-select v-model="account.isOpenAllAff" placeholder="Affiliates">
                <el-option
                  v-for="item in isOpenAllAffOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmClick">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改角色模块框 -->
      <el-dialog title="Update Role" width="40%" :visible.sync="updateVisible">
        <el-form :model="updateRole" label-position="left" label-width="100px">
          <el-row>
            <el-col :lg="10" :md="20">
              <el-form-item label="Account Role" label-width="100px">
                <el-select v-model="updateRole.roleId" style="width:240px;" multiple>
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="updateVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmUpdateClick">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 删除提示框 -->
      <el-dialog title="Delete" :visible.sync="delVisible" width="300px" center append-to-body>
        <div class="del-dialog-cnt">Confirm to delete ?</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="delVisible = false">cancel</el-button>
          <el-button type="primary" @click="delRow">confirm</el-button>
        </span>
      </el-dialog>
    </template>
  </base-list-layout>
</template>
<script>
  import {
    getAccountList,
    insertAccount,
    updateAccount,
    deleteAccount,
    getRoleList,
    bindRole,
  } from 'api/account';
  import Pagination from '@/components/pagination';
  import { myMixin } from '@/mixins/mixins.js';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { validateEmail } from 'utils/validator';

  const defaultAccount = {
    username: '',
    email: '',
    password: '',
    description: '',
    roles: [],
    isOpenAllAdv: 0,
    isOpenAllAff: 0,
  };
  export default {
    mixins: [myMixin],
    components: {
      BaseListLayout,
      Pagination,
    },
    data() {
      return {
        pageSize: 100,
        accountId: null,
        delVisible: false,
        updateAccountVisible: false,
        rules: {
          email: [
            {
              validator: validateEmail,
              required: true,
            },
          ],
          username: [{ required: true }],
        },
        isOpenAllAffOptions: [
          {
            label: 'yes',
            value: 1,
          },
          {
            label: 'no',
            value: 0,
          },
        ],
        isOpenAllAdvOptions: [
          {
            label: 'yes',
            value: 1,
          },
          {
            label: 'no',
            value: 0,
          },
        ],
        currentPage: 1,
        roleOptions: [],
        consoleAccount: {
          accountId: null,
          username: null,
        },
        total: null,
        listLoading: false,
        userNameValue: '',
        statusOptions: [
          {
            label: 'ENABLE',
            value: 'ENABLE',
          },
          {
            label: 'DISABLE',
            value: 'DISABLE',
          },
        ],
        consoleAccountList: [],
        account: Object.assign({}, defaultAccount),
        updateRole: {
          roleId: [],
        },
        dialogType: 'new',
        dialogVisible: false,
        updateVisible: false,
        id: '',
      };
    },
    mounted() {
      this.getDataList();
      this.searchListClick(1);
    },
    methods: {
      searchListClick(page) {
        this.listLoading = true;
        let param = {};
        if (this.consoleAccount.accountId != null) {
          param['accountId'] = this.consoleAccount.accountId;
        }
        if (this.consoleAccount.accountName != null) {
          param['accountName'] = this.consoleAccount.accountName;
        }
        if (page) {
          this.currentPage = 1;
        }
        param['page'] = this.currentPage;
        param['pageSize'] = this.pageSize;
        getAccountList(param).then((response) => {
          this.listLoading = false;
          if (response.code == 200) {
            this.consoleAccountList = response.result;
            this.total = response.total;
          } else {
            this.$message.error('Error' + response.message);
          }
        });
      },
      getDataList() {
        let param = {};
        getRoleList(param).then((response) => {
          if (response.code === 200) {
            let array = response.result;
            let rolesMap = [];
            array.forEach((item) => {
              rolesMap.push({
                value: item.id,
                label: item.roleName,
              });
            });
            this.roleOptions = rolesMap;
          } else {
            this.$message.error(response.message);
          }
        });
      },
      addClick() {
        this.account = Object.assign({}, defaultAccount);
        this.dialogType = 'new';
        this.dialogVisible = true;
      },
      updateAccountClick(row) {
        this.account = {
          id: row.accountId,
          description: row.description,
          isOpenAllAdv: row.isOpenAllAdv,
          isOpenAllAff: row.isOpenAllAff,
        };
        this.dialogType = 'edit';
        this.dialogVisible = true;
      },
      delAccountClick(row) {
        this.accountId = row.accountId;
        this.delVisible = true;
      },
      delRow() {
        deleteAccount(this.accountId).then((response) => {
          if (response.code == 200) {
            this.$message({
              message: 'Delete Success',
              type: 'success',
            });
            this.searchListClick();
            this.delVisible = false;
          } else {
            this.$message.error('Error' + response.message);
          }
        });
      },
      confirmClick() {
        this.$refs.baseForm.validate((valid) => {
          if (valid) {
            const isEdit = this.dialogType === 'edit';
            if (!isEdit) {
              insertAccount({ ...this.account }).then((response) => {
                if (response.code === 200) {
                  this.$message({
                    message: 'Add Success',
                    type: 'success',
                  });
                  this.searchListClick();
                  this.dialogVisible = false;
                } else {
                  this.$message.error('Error' + response.message);
                }
              });
            } else {
              updateAccount({ ...this.account }).then((response) => {
                if (response.code === 200) {
                  this.$message({
                    message: 'Update Success',
                    type: 'success',
                  });
                  this.searchListClick();
                  this.dialogVisible = false;
                } else {
                  this.$message.error('Error' + response.message);
                }
              });
            }
          }
        });
      },
      updateClick(row) {
        this.updateRole.roleId = [];
        this.accountId = row.accountId;
        for (var i = 0; i < row.roles.length; i++) {
          this.updateRole.roleId.push(row.roles[i].id);
        }
        this.updateVisible = true;
      },
      confirmUpdateClick() {
        if (this.updateRole.roleId.length == 0) {
          this.$message.error('一个用户至少拥有一个角色');
          return;
        }
        bindRole(this.accountId, [...this.updateRole.roleId]).then((response) => {
          if (response.code === 200) {
            this.$message({
              message: response.message,
              type: 'success',
            });
            this.searchListClick();
            this.updateVisible = false;
          } else {
            this.$message.error(response.message);
          }
        });
      },
      handleSizeChange(size) {
        this.pageSize = size;
        this.handleCurrentChange(1);
      },
      handleCurrentChange(currentPage) {
        this.currentPage = currentPage;
        this.searchListClick();
      },
    },
  };
</script>
<style lang="scss" scoped></style>
